<script setup lang="ts">
import { Toasts } from '@laravel-inertia-toast/vue';
import AppContent from '@/components/AppContent.vue';
import AppShell from '@/components/AppShell.vue';
import AppSidebar from '@/components/AppSidebar.vue';
import AppSidebarHeader from '@/components/AppSidebarHeader.vue';
import ImpersonationBanner from '@/components/ImpersonationBanner.vue';
import PersistentAlerts from '@/components/PersistentAlerts.vue';
import { useNotifications } from '@/composables/useNotifications';
import type { BreadcrumbItem } from '@/types';

type Props = {
    breadcrumbs?: BreadcrumbItem[];
};

withDefaults(defineProps<Props>(), {
    breadcrumbs: () => [],
});

// Phase 8 — temps réel : Reverb (badge + toast + son) ou polling de secours.
const { setup: setupRealtime } = useNotifications();

setupRealtime();
</script>

<template>
    <AppShell variant="sidebar">
        <AppSidebar />
        <AppContent variant="sidebar" class="overflow-x-hidden">
            <ImpersonationBanner />
            <AppSidebarHeader :breadcrumbs="breadcrumbs" />
            <PersistentAlerts class="px-4 pt-4" />
            <slot />
        </AppContent>
        <Toasts />
    </AppShell>
</template>
